import { configureStore } from '@reduxjs/toolkit';
import { userSlice } from './user';
import { companiesSlice } from './companies';
import { companySlice } from './company';

export const store = configureStore({
    reducer: {
        users: userSlice.reducer,
        companies: companiesSlice.reducer,
        companyName: companySlice.reducer
    },
})

export type RootState = ReturnType<typeof store.getState>
export type StoreDispatch = typeof store.dispatch